import firebaseService, { FirebaseService } from "services/firebase.service";

import FirebaseContext, { withFirebase } from "./Context";
export default firebaseService;
export { FirebaseService as Firebase, FirebaseContext, withFirebase };
